import { render, staticRenderFns } from "./settings-view.vue?vue&type=template&id=3a48a073&scoped=true"
import script from "./settings-view.vue?vue&type=script&lang=js"
export * from "./settings-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a48a073",
  null
  
)

export default component.exports